import styled from '@emotion/styled';

export const SectionWrapper = styled.div`
  background: ${({ theme, index }) =>
    index % 2 ? 'white' : theme.colors.neutralLight};
  border: ${({ theme }) => `1px solid ${theme.colors.neutral50}`};
  margin-top: 40px;
`;
